import * as React from "react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import Routes from "routing/Routes";
import { MenuItem, DeleteMenuItem, BootstrapModalConfirm } from "components/bootstrap";
import { Spinner } from "components/common";
import useScopePermissions from "hooks/useScopePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { useDeleteCache } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { MoreActionsMenu } from "components/common/MoreActions";
function Actions({ cache }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { deleteCache, deletingCache } = useDeleteCache();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(cache);
  const navigate = useNavigate();
  const handleEdit = useCallback(() => {
    navigate(Routes.SYSTEM.LOOKUPTABLES.CACHES.edit(cache.name));
  }, [navigate, cache.name]);
  const handleDelete = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LUT.CACHE_DELETED, {
      app_pathname: "lut",
      app_section: "lut_cache"
    });
    deleteCache(cache.id).then(() => setShowDeleteModal(false));
  }, [cache.id, sendTelemetry, deleteCache]);
  if (loadingScopePermissions) return /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  if (!scopePermissions.is_mutable) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsMenu, { id: cache.id, size: "lg", pullRight: true, title: `More Actions for ${cache.name}` }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: handleEdit }, "Edit"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteModal(true) }, "Delete")), showDeleteModal && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: true,
      title: "Delete Cache",
      onCancel: () => setShowDeleteModal(false),
      onConfirm: handleDelete,
      cancelButtonDisabled: deletingCache,
      confirmButtonDisabled: deletingCache,
      confirmButtonText: "Delete"
    },
    /* @__PURE__ */ React.createElement("p", null, 'Are you sure you want to delete the cache "', cache.title, '"?')
  ));
}
const renderActions = (cache) => /* @__PURE__ */ React.createElement(Actions, { cache });
function useActions() {
  return {
    renderActions
  };
}
export default useActions;
